export default __webpack_public_path__ + "static/4-7e3d002257218bd2de49e0499ff3ad25.jpeg";